import {IconAutoPay, IconCancelAutoPay, IconNoEntry, IconPay, IconSwitch, IconWallet} from "../../../bounce-ui/assets";
import React from "react";
import {useDashboardMenuContent} from "./useDashboardMenuContent";
import MenuItemDivider from "../MenuItemDivider";
import CustomMenuItem from "../CustomMenuItem";

interface Props {
  onClose: () => void;
  hasDivider?: boolean;
}

const DashboardMenuContent = ({onClose, hasDivider = false}: Props) => {
  const {
    onOneTimePaymentClick,
    onPaymentMethodChangeClick,
    onCancelMyPlanClick,
    onCancelAutoPayClick,
    onSwitchToAutoPayClick,
    onDisplayPreviewPlans,
    shouldDisplayCancelAutoPay,
    shouldDisplayCancelMyPlan,
    shouldDisplaySwitchToAutoPay,
    shouldDisplayDashboardMenu,
    shouldDisplayPreviewPlans,
  } = useDashboardMenuContent({onClose});

  if (!shouldDisplayDashboardMenu) return null;

  return (
    <>
      <CustomMenuItem
        label="One time payment"
        icon={<IconPay height={20} width={20} />}
        onClick={onOneTimePaymentClick}
      />
      <CustomMenuItem
        label="Change payment method"
        icon={<IconWallet height={20} width={20} />}
        onClick={onPaymentMethodChangeClick}
      />
      {shouldDisplayCancelMyPlan && (
        <CustomMenuItem
          onClick={onCancelMyPlanClick}
          label="Cancel my plan"
          icon={<IconNoEntry height={20} width={20} />}
        />
      )}
      {shouldDisplaySwitchToAutoPay && (
        <CustomMenuItem
          onClick={onSwitchToAutoPayClick}
          label="Switch to AutoPay"
          icon={<IconAutoPay height={20} width={20} />}
        />
      )}
      {shouldDisplayCancelAutoPay && (
        <CustomMenuItem
          onClick={onCancelAutoPayClick}
          label="Cancel AutoPay"
          icon={<IconCancelAutoPay height={20} width={20} />}
        />
      )}
      {shouldDisplayPreviewPlans && (
        <CustomMenuItem
          onClick={onDisplayPreviewPlans}
          label="See alternate plans"
          icon={<IconSwitch height={20} width={20} />}
        />
      )}
      {hasDivider && <MenuItemDivider />}
    </>
  );
};

export default DashboardMenuContent;
